"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adjectives_1 = require("./adjectives");
const animals_1 = require("./animals");
const cleanReadableId = () => {
    const adjective = adjectives_1.default[Math.floor(Math.random() * adjectives_1.default.length)];
    const animal = animals_1.default[Math.floor(Math.random() * animals_1.default.length)];
    const number = Math.floor(Math.random() * 100);
    return `${adjective}-${animal}-${number}`;
};
exports.default = cleanReadableId;
//# sourceMappingURL=cleanReadableId.js.map